'use client';

import React, { useEffect, useState } from 'react';
import './flip.css';

const FlipUnit = ({ value }) => {
  const [prevValue, setPrevValue] = useState(value);
  const [flipping, setFlipping] = useState(false);

  useEffect(() => {
    if (value !== prevValue) {
      setFlipping(true);
      const timeout = setTimeout(() => {
        setFlipping(false);
        setPrevValue(value);
      }, 600);
      return () => clearTimeout(timeout);
    }
  }, [value, prevValue]);

  return (
    <div className="flip-container">
      <div className="flip-upper">
        <div className="flip-top">{flipping ? prevValue : value}</div>
        <div className={`flip-top-animate ${flipping ? 'animate' : ''}`}>
          {prevValue}
        </div>
      </div>
    </div>
  );
};

export default FlipUnit;
